export const validateAmountNotification = (value) => {
    if(value >= 1 && value <= 4){
        return { code: 1, helperText: ''}
    }
    return { code: 2, helperText: 'Número no valido'}
}

export const validateAmountWaitedTime = (value) => {
    if(value >= 2 && value <= 6){
        return { code: 1, helperText: ''}
    }
    return { code: 2, helperText: 'Número no valido'}
}